import type { Theme } from '@mui/material/styles';

type TypographyVariant = 'h1' | 'h4' | 'h6' | 'body1' | 'body2';

export function typographyCss(theme: Theme, variant: TypographyVariant) {
  const typography = theme.typography[variant];

  return {
    fontFamily: typography.fontFamily,
    fontSize: typography.fontSize,
    lineHeight: typography.lineHeight,
    letterSpacing: typography.letterSpacing,
  };
}
